import CalvinLogo from "./CalvinUniv-vert-full-color-inverse.png";

export const logo = CalvinLogo;
